/** Fechas de la app: Europe/Madrid, dd/mm/aaaa y dd/mm/aaaa HH:mm. */

export const TZ_MADRID = "Europe/Madrid";

export function esFechaSolo(valor) {
  return /^\d{4}-\d{2}-\d{2}$/.test(String(valor || "").trim());
}

export function parseInstant(valor) {
  if (valor == null || valor === "") return null;
  if (valor instanceof Date) return Number.isNaN(valor.getTime()) ? null : valor;
  if (typeof valor === "number") {
    const d = new Date(valor);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const s = String(valor).trim();
  if (!s) return null;
  if (esFechaSolo(s)) return new Date(`${s}T12:00:00`);
  let iso = s;
  if (/^\d{4}-\d{2}-\d{2}T/.test(s) && !/[zZ]$/.test(s) && !/[+-]\d{2}:?\d{2}$/.test(s)) {
    iso = `${s}Z`;
  }
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

function partesMadrid(d) {
  const fmt = new Intl.DateTimeFormat("es-ES", {
    timeZone: TZ_MADRID,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    hourCycle: "h23",
  });
  const map = {};
  for (const p of fmt.formatToParts(d)) {
    if (p.type !== "literal") map[p.type] = p.value;
  }
  return {
    date: `${map.day}/${map.month}/${map.year}`,
    time: `${map.hour}:${map.minute}`,
  };
}

export function fmtFecha(valor) {
  if (valor == null || valor === "") return "\u2014";
  const s = String(valor).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m && (esFechaSolo(s) || /T00:00:00/.test(s))) {
    return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = parseInstant(valor);
  if (!d) return "\u2014";
  return partesMadrid(d).date;
}

export function fmtFechaHora(valor) {
  if (valor == null || valor === "") return "\u2014";
  const d = parseInstant(valor);
  if (!d) return "\u2014";
  const p = partesMadrid(d);
  return `${p.date} ${p.time}`;
}

export function horaMadrid(valor) {
  const d = valor == null || valor === "" ? new Date() : parseInstant(valor);
  if (!d) return 0;
  return Number(new Intl.DateTimeFormat("es-ES", {
    timeZone: TZ_MADRID,
    hour: "numeric",
    hourCycle: "h23",
  }).format(d));
}

export function fechaTransportePorDefecto(fechaAlbaran) {
  const hoy = ymdMadrid(new Date());
  const alb = String(fechaAlbaran || "").trim().slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(alb) && alb >= hoy) return alb;
  return hoy;
}

export function ymdMadrid(valor) {
  if (esFechaSolo(valor)) return String(valor).trim().slice(0, 10);
  const d = parseInstant(valor);
  if (!d) return "";
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ_MADRID,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}
